import { Box, Link as MuiLink, Stack, Typography } from "@mui/material";
import GlassCard from "Components/GlassCard/GlassCard";
import Loading from "Components/Loading/Loading";
import ProductAnalyticsCard from "features/products/components/ProductAnalyticsCard";
import { useTopPerformingProducts } from "features/products/hooks/useTopPerformingProducts";
import { useProducts } from "Hooks/useProducts";
import { useSelectedProject } from "Hooks";
import { RouteNames } from "Hooks/routeNames";
import useProtectedRoutes from "Hooks/useProtectedRoutes";
import { useCallback } from "react";
import { Link, useHistory } from "react-router-dom";

function StoreBestProductHighlight() {
  const history = useHistory();
  const { selectedProject, selectedClient } = useSelectedProject();
  const { pathByName } = useProtectedRoutes();
  const { products } = useProducts();
  const {
    products: topProducts,
    loading,
    tabConfig,
  } = useTopPerformingProducts([], "top_sellers");
  const topProduct = topProducts[0];

  const onProductClick = useCallback(
    (productId?: number) => {
      if (!productId || !selectedProject?.id || !selectedClient?.id) {
        return;
      }

      history.push(
        pathByName(RouteNames.PRODUCT_DEEP_DIVE, {
          clientId: selectedClient.id,
          projectId: selectedProject.id,
        }),
        { selectedProductId: productId },
      );
    },
    [history, pathByName, selectedClient?.id, selectedProject?.id],
  );

  const productPerformancePath =
    selectedClient?.id && selectedProject?.id
      ? pathByName(RouteNames.STORE_PRODUCT_PERFORMANCE, {
          clientId: selectedClient.id,
          projectId: selectedProject.id,
        })
      : "#";

  return (
    <GlassCard
      sx={{ height: "100%" }}
      boxProps={{
        p: 2.5,
        height: "100%",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        mb={2}
      >
        <Typography variant="subtitle1" fontWeight={700}>
          Top Performer
        </Typography>
        <MuiLink
          component={Link}
          to={productPerformancePath}
          underline="hover"
          sx={{ fontWeight: 600, fontSize: 14, whiteSpace: "nowrap" }}
        >
          View All →
        </MuiLink>
      </Stack>

      <Box
        sx={{
          flex: 1,
          minHeight: 0,
          display: "flex",
          alignItems: "stretch",
        }}
      >
        {loading && !topProduct ? (
          <Box sx={{ flex: 1, display: "flex", alignItems: "center" }}>
            <Loading />
          </Box>
        ) : !topProduct ? (
          <Typography
            color="text.secondary"
            textAlign="center"
            sx={{ m: "auto" }}
          >
            No product performance data for this period.
          </Typography>
        ) : (
          <ProductAnalyticsCard
            product={topProduct}
            products={products}
            trendMetric={tabConfig.trendMetric}
            leadMetric={tabConfig.leadMetric}
            fullWidth
            onClick={onProductClick}
          />
        )}
      </Box>
    </GlassCard>
  );
}

export default StoreBestProductHighlight;
